/* import __COLOCATED_TEMPLATE__ from './api-panels.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();